import { lazy, Suspense, useEffect, useState } from "react";
import FullPageLoader from "@/ui/fullPageLoader/FullPageLoader";
import { usePageTitle } from "@/i18n/usePageTitle";
import { useCurrentLanguage } from "@/i18n/useLocalized";
import BosnianViewNotice from "@/pages/legal/BosnianViewNotice";
import TermsAndConditionsBosnian from "./TermsAndConditions.bs.jsx";

// Bosnian stays in the main bundle, as before; English loads only when read.
const TermsAndConditionsEnglish = lazy(() => import("./TermsAndConditions.en.jsx"));

export default function TermsAndConditions() {
	usePageTitle("seo:titles.terms");
	const language = useCurrentLanguage();
	// "Read the Bosnian version" is a view choice for this page only, and it
	// ends when the language changes.
	const [showBosnian, setShowBosnian] = useState(false);
	useEffect(() => setShowBosnian(false), [language]);

	// Bosnian readers get the Bosnian page exactly as before, with no note.
	if (language !== "en") return <TermsAndConditionsBosnian />;

	if (showBosnian)
		return (
			<TermsAndConditionsBosnian
				notice={<BosnianViewNotice onReadEnglish={() => setShowBosnian(false)} />}
			/>
		);

	return (
		<Suspense fallback={<FullPageLoader />}>
			<TermsAndConditionsEnglish onReadBosnian={() => setShowBosnian(true)} />
		</Suspense>
	);
}
